import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { Link } from '@gemini/ui';
import Links from '@components/SeoLinks/Links';
const SeoLinks = (props) => {
    return (_jsxs(Box, { as: "div", marginTop: {
            'breakpoint.base': 'spacing.56',
            'breakpoint.md': 'spacing.80',
        }, children: [_jsx(Box, { as: "div", marginBottom: "spacing.24", typography: {
                    'breakpoint.base': 'typography.headline.22.bold',
                    'breakpoint.md': 'typography.headline.28.bold',
                }, children: props.title }), _jsx(Box, { as: "div", children: _jsx(Box, { as: "ul", unsafe_style: { listStyleType: 'none', padding: 0 }, display: "grid", gridTemplateColumns: {
                        'breakpoint.base': '1fr',
                        'breakpoint.md': '1fr 1fr 1fr',
                    }, gap: {
                        'breakpoint.base': 'spacing.8',
                        'breakpoint.md': 'spacing.16',
                    }, children: Links.map((link, key) => (_jsx(Box, { as: "li", paddingVertical: "spacing.8", children: _jsx(Link, { href: link.url, isExternal: true, children: link.text }) }, key))) }) })] }));
};
export default SeoLinks;
